var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5650_4323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7544 24.4962C8.99144 24.4962 3.50889 19.0137 3.50889 12.2506C3.50889 5.48756 8.99138 0.00512695 15.7544 0.00512695C22.5175 0.00512695 28 5.48762 28 12.2507C28 19.0138 22.5175 24.4962 15.7544 24.4962ZM15.7544 3.50388C10.9237 3.50388 7.00763 7.41994 7.00763 12.2507C7.00763 17.0814 10.9237 20.9975 15.7544 20.9975C20.5852 20.9975 24.5013 17.0814 24.5013 12.2507C24.5013 7.41994 20.5851 3.50388 15.7544 3.50388Z",
    fill: "#F83758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75951 27.995C1.29451 27.9977 0.847592 27.8151 0.51747 27.4876C-0.168521 26.8072 -0.173043 25.6997 0.50734 25.0137C0.510717 25.0103 0.514093 25.0069 0.51747 25.0035L7.09507 18.426C7.80518 17.74 8.93694 17.7596 9.62293 18.4697C10.3089 19.1798 10.2893 20.3115 9.57922 20.9975L3.00156 27.4876C2.67143 27.8151 2.22452 27.9977 1.75951 27.995Z",
    fill: "#F83758"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5650_4323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRedIcon);
export default __webpack_public_path__ + "static/media/searchRedIcon.58f5e21d2d2191cb68f20d91a80de199.svg";
export { ForwardRef as ReactComponent };